/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's opyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

import React, { forwardRef, ReactElement, PropsWithChildren } from "react";

export type Ref = HTMLButtonElement;

export const ForwardRef = forwardRef<Ref, PropsWithChildren>(
  ({ children, ...props }, ref) => {
    // Type check for children to ensure it's a valid React element
    const child = React.Children.only(
      children
    ) as ReactElement<Record<string, unknown>> | null;

    return (
      <>{child && React.cloneElement(child, { forwardRef: ref, ...props })}</>
    );
  }
);
